import Grid from '@zenbusiness/zui/Grid';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function FieldDetail({ label, value, loading, xs = 12, lg = 4 }) {
  if (!loading && !value) {
    return null;
  }

  return (
    <Grid
      item
      lg={lg}
      xs={xs}
    >
      <Stack
        direction="column"
        gap="8px"
      >
        <Text
          color="secondary"
          size="xs"
          uppercase
        >
          {label}
        </Text>
        {loading ? (
          <Skeleton />
        ) : (
          <Text
            color="primary"
            size="lg"
          >
            {value}
          </Text>
        )}
      </Stack>
    </Grid>
  );
}

FieldDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  loading: PropTypes.bool,
  xs: PropTypes.number,
  lg: PropTypes.number
};
